import React from 'react'
// libs
import styled from 'styled-components'
// components
import MaterialMenu, { MenuProps } from '@mui/material/Menu'
import MaterialMenuItem from '@mui/material/MenuItem'
// themes
import colors from 'themes/colors'

export const DefaultMenuItem = styled(MaterialMenuItem)`
  && {
    padding: 0;
    color: ${colors.blue500};

    & > * {
      display: flex;
      height: 100%;
      min-width: 100px;
      padding: 4px 12px;
      width: 100%;
    }
      
      svg {
          height: 20px;
          margin-right: 4px;
      }
  }
`

const anchorOrigin = {
  vertical: 'bottom' as const,
  horizontal: 'left' as const
}

interface Props extends Omit<MenuProps, 'open'> {
  trigger: React.ReactElement
  MenuItem?: React.ComponentType<any>
}

const Menu: React.FC<Props> = ({ trigger, children, MenuItem = DefaultMenuItem, disableAutoFocusItem }) => {
  const [anchor, setAnchor] = React.useState(null)

  const emptyAnchor = (event?: React.MouseEvent<HTMLElement>) => {
    event?.stopPropagation()
    setAnchor(null)
  }

  return (
    <>
      {React.cloneElement(trigger, {
        onClick: (event: React.MouseEvent<HTMLElement>) => {
          event.stopPropagation()
          setAnchor(event.currentTarget)
        },
        'aria-haspopup': true,
        'aria-owns': anchor ? 'menu' : undefined
      })}
      <MaterialMenu
        id={'menu'}
        open={!!anchor}
        anchorEl={anchor}
        onClose={emptyAnchor}
        anchorOrigin={anchorOrigin}
        disableAutoFocusItem={disableAutoFocusItem}>
        {React.Children.map(children, (child, index) => {
          if (!child) {
            return null
          }

          if (React.isValidElement(child) && child.key === 'title') {
            return child
          }

          const handleOnClick = (event: React.MouseEvent) => {
            event.stopPropagation()
            emptyAnchor()
          }

          return (
            <MenuItem onClick={handleOnClick} key={index}>
              {child}
            </MenuItem>
          )
        })}
      </MaterialMenu>
    </>
  )
}

export default Menu
